import React from "react";
import { useApolloClient } from "@apollo/client";

import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { Fieldset } from "primereact/fieldset";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

/** contexts */
import { useSettings } from "../../context/settings";

/** providers */
import SAVE_CALL from "../../provider/Calls/mutation";

/** utils */
import { getGraphsqErros } from "../../utilities/functions";

/** services */
import { getUser } from "../../services/auth";

import Prescription from "./print";

const Call: React.FC<iProps> = ({ person, setPerson, setVisibleCall, medicines = [], callback = () => {} }) => {
    const settings = useSettings();
    const apollo = useApolloClient();
    const toast = React.useRef<any>(null);

    const [loading, setLoading] = React.useState<boolean>(false);
    const [showPrint, setVisiblePrint] = React.useState<boolean>(false);

    const [callId, setCallId] = React.useState("");

    const onNewMedicine = () => {
        let _record: any = { ...person };

        if (_record?.call?.items.data) {
            _record.call.items.data.push({ medicine: undefined, dosage: "", amount: 1 });
        } else {
            _record = {
                ..._record,
                call: { items: { data: [{ medicine: undefined, dosage: "", amount: 1 }] }, patient_id: person?.id, user_id: getUser()?.id },
            };
        }

        setPerson(_record);
    };

    const onMedicineRemove = (index: number) => {
        let _record: any = { ...person };

        _record.call.items.data = _record.call.items.data.filter((item: any, i: any) => i !== index);

        setPerson(_record);
    };

    const onMedicineChange = (e: any, name: string, index: number) => {
        let val = (e.target && e.target.value) || "";

        let _record: any = { ...person };
        if (_record.call && _record.call.items && _record.call.items.data) {
            if (Array.isArray(_record.call?.items.data)) {
                if (name === "medicine_id") _record.call.items.data[index][name] = val.id;
                else if (name === "amout") _record.call.items.data[index][name] = parseInt(val);
                else _record.call.items.data[index][name] = val;
            }
        }

        setPerson(_record);
    };

    const onMedicineValuesChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || "";

        let _record: any = { ...person };

        if (!_record.call) {
            _record = {
                ..._record,
                call: { items: { data: [] }, patient_id: person?.id, user_id: getUser()?.id },
            };
        }

        _record.call[name] = val;
        console.log(_record);
        setPerson(_record);
    };

    const RenderFooter = () => (
        <>
            <div className="field col-12 md:col-12 p-5 flex justify-content-end ">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    disabled={loading}
                    className="p-button-text text-red-500 p-button-sm"
                    onClick={() => setVisibleCall(false)}
                />

                {person?.call?.id || callId ? (
                    <Button
                        label={"Imprimir"}
                        disabled={loading}
                        icon="pi pi-print"
                        className="p-button-info p-button-md ml-2"
                        onClick={() => {
                            setCallId(`${person?.call?.id || callId}`);
                            setVisiblePrint(true);
                        }}
                    />
                ) : null}
                <Button
                    label={loading ? "Salvando..." : "Salvar"}
                    disabled={loading}
                    icon="pi pi-check"
                    className="p-button-success p-button-lg ml-2"
                    onClick={saveRecord}
                />
            </div>
        </>
    );

    const saveRecord = () => {
        const _record: any = { ...person?.call };

        delete _record.__typename;

        setLoading(true);
        let mutation = SAVE_CALL;

        if (_record?.id) {
            _record.id = parseInt(`${_record.id}`);
        }
        _record.mission_id = parseInt(settings.MISSION_ID);
        _record.user_id = parseInt(`${getUser()?.id}`);
        _record.patient_id = parseInt(`${person?.id}`);

        if (!_record?.items?.data) _record.items = { data: [] };

        _record.items.data = _record.items.data
            ?.filter((i: any) => i.medicine_id)
            .map((i: any) => {
                // i.medicine_id = parseInt(`${i.medicine?.id}`);
                delete i.medicine;

                return i;
            });

        apollo
            .mutate({
                mutation,
                variables: {
                    data: {
                        ..._record,
                    },
                },
            })
            .then(response => {
                setLoading(false);

                setCallId(response.data.saveCall);
                toast.current.show({ severity: "success", summary: "Sucesso", detail: "Registro salvo com sucesso.", life: 3000 });

                // setVisiblePrint(true);
                // setTimeout(() => setVisibleCall(false), 1000);

                callback();
            })
            .catch(error => {
                setLoading(false);
                settings.setErrorMessage(getGraphsqErros(error));
                settings.setVisibleError(true);
            });
    };

    return (
        <>
            <Toast ref={toast} />
            <Fieldset legend="Triagem" toggleable>
                <p>
                    <b style={{ fontSize: 16 }}>Peso: </b> {person?.sorting?.weight ?? "-"} &nbsp;&nbsp;|&nbsp;&nbsp;
                    <b style={{ fontSize: 16 }}>Altura: </b> {person?.sorting?.height ?? "-"}
                </p>
                <p></p>
                <p>
                    <b style={{ fontSize: 16 }}>Pressão arterial: </b> {person?.sorting?.pressure ?? "-"} &nbsp;&nbsp;|&nbsp;&nbsp;
                    <b style={{ fontSize: 16 }}>IMC: </b> {person?.sorting?.imc ?? "-"}
                </p>

                <p>
                    <b style={{ fontSize: 16 }}>Temperatura: </b> {person?.sorting?.temperature ?? "-"}º &nbsp;&nbsp;|&nbsp;&nbsp;
                    <b style={{ fontSize: 16 }}>Frequencia Respiratória: </b> {person?.sorting?.respiratory_frequency ?? "-"}
                </p>

                <p>
                    <b style={{ fontSize: 16 }}>Saturação: </b> {person?.sorting?.saturation ?? "-"}
                </p>

                <p>
                    <b style={{ fontSize: 16 }}>Observações </b>
                    <br />
                    {person?.sorting?.notes ?? "-"}
                </p>
            </Fieldset>

            <Fieldset className="mt-2" legend="Diagnóstico & Anamnese" toggleable>
                <div className="flex flex-column md:flex-row flex-wrap ">
                    <div className="field col-12 md:col-6 flex flex-column">
                        <label htmlFor="diagnosis">Diagnóstico</label>
                        <InputTextarea
                            autoFocus
                            id="diagnosis"
                            rows={3}
                            style={{ resize: "none" }}
                            value={person?.call?.diagnosis}
                            autoComplete={"new-password"}
                            onChange={e => onMedicineValuesChange(e, "diagnosis")}
                            className={classNames("p-3", {})}
                        />
                    </div>

                    <div className="field col-12 md:col-6 flex flex-column">
                        <label htmlFor="anamnesis">Anamnese</label>
                        <InputTextarea
                            id="anamnesis"
                            rows={3}
                            style={{ resize: "none" }}
                            value={person?.call?.anamnesis}
                            autoComplete={"new-password"}
                            onChange={e => onMedicineValuesChange(e, "anamnesis")}
                            className={classNames("p-3", {})}
                        />
                    </div>
                </div>
            </Fieldset>

            <Fieldset className="mt-2" legend="Receituário" toggleable>
                <div className="flex flex-column md:flex-row flex-wrap ">
                    <div className="field col-12 md:col-12">
                        <div className="flex align-items-center justify-content-end mb-0 p-0 pb-0 mt-0">
                            <Button label="Adicionar" icon="pi pi-plus" className="p-button-text" onClick={event => onNewMedicine()} />
                        </div>
                        {person?.call && person?.call.items && person?.call.items?.data ? (
                            <>
                                {person?.call.items.data.map((item: any, index: number) => (
                                    <div key={`dosage-${index}`} className="flex flex-column md:flex-row flex-wrap ">
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="start_hour">* Medicamento</label>

                                            <Dropdown
                                                style={{ width: "100%", padding: "0.6rem !important" }}
                                                value={medicines
                                                    .map(i => ({ id: i.id, name: `${i.name} (${i.stock})` }))
                                                    .find(i => `${i.id}` === `${person.call?.items.data[index].medicine_id}`)}
                                                options={medicines.map(i => ({ id: i.id, name: `${i.name} (${i.stock})` }))}
                                                onChange={e => {
                                                    onMedicineChange(e, "medicine", index);
                                                    onMedicineChange(e, "medicine_id", index);
                                                }}
                                                optionLabel="name"
                                                filter
                                                showClear
                                                filterBy="name"
                                                placeholder="Selecione o medicamento"
                                                className={classNames("p-2", {})}
                                            />
                                        </div>

                                        <div className="field col-12 md:col-2">
                                            <label htmlFor="amount">* Quantidade</label>

                                            <div className="p-inputgroup">
                                                <InputText
                                                    id="amount"
                                                    type={"number"}
                                                    value={person.call?.items.data[index].amount}
                                                    autoComplete={"new-password"}
                                                    onChange={e => onMedicineChange(e, "amount", index)}
                                                    className={classNames("p-3", {})}
                                                />
                                            </div>
                                        </div>

                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="dosage">* Dosagem</label>

                                            <div className="p-inputgroup">
                                                <InputText
                                                    id="dosage"
                                                    type={"text"}
                                                    value={person.call?.items.data[index].dosage}
                                                    autoComplete={"new-password"}
                                                    onChange={e => onMedicineChange(e, "dosage", index)}
                                                    className={classNames("p-3", {})}
                                                />
                                                <Button icon="pi pi-fw pi-minus" className="btn-success" onClick={() => onMedicineRemove(index)} />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : null}
                    </div>
                </div>
            </Fieldset>
            <RenderFooter />
            <Sidebar style={{ minWidth: "100vw" }} visible={showPrint} onHide={() => setVisiblePrint(false)} baseZIndex={1000000} position="right">
                <Prescription call_id={callId} setVisible={setVisiblePrint} medicines={medicines} />
            </Sidebar>
        </>
    );
};

export default Call;

interface iProps {
    person: iPeople | undefined;
    setPerson: Function;
    setVisibleCall: Function;
    medicines: iMedicine[];
    callback: Function;
}
